<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>账单详情</h4>
          <div @click="back"><i class="fa fa-reply"></i></div>
        </div>
        <!-- 查询条件 -->
        <div class="formBox margbot">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
             <el-form-item label="运单号:"    class="item1">
                <el-input  placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNos" ></el-input>
            </el-form-item>
             <el-form-item label="开票状态:" >
                 <el-select v-model="searchFrom.yfInvoicingStates" placeholder="请选择开票状态">
                    <el-option v-for="item in yfInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                  </el-select>
              </el-form-item>
            <div style="">
              <el-form-item>
                 <el-button type="primary" size="mini" @click="getList">查询</el-button>
                <el-button type="primary" size="mini" @click="chongZhi1">重置</el-button>
                <!-- <el-button type="primary" size="mini" @click="addYFFn" v-if="btnFlg[0]">添加应付</el-button>
                <el-button type="primary" size="mini" @click="delFn" v-if="btnFlg[1]">删除</el-button> -->
                <el-button type="primary" size="mini" @click="buFenKPFn" v-if="btnFlg[2]">部分开票</el-button>
                <el-button type="primary" size="mini" @click="buFenFKFn" v-if="btnFlg[3]">部分付款</el-button>
                <el-button type="primary" size="mini" @click="fuKuanFn" v-if="btnFlg[4]">付款</el-button>
                <el-button type="primary" size="mini" @click="kaiPiaoFn" v-if="btnFlg[5]">开票</el-button>
              </el-form-item>
              <span>
                <el-form-item>
                  <p class="margin0">已选未付款金额：<span class="red">{{fuKuanFrom.pendingAmount}}</span>元</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">已选未开票金额：<span class="red">{{kaiPiaoFrom.invoiceAmount}}</span>元</p>
                </el-form-item>
              </span>
            </div>
          </el-form>
        </div>
      </div>
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table :data="tableList" ref="tableList" class="tableComent" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
        :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'
        >
          <el-table-column type="selection" width="50" fixed></el-table-column>
          <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
          <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
          <el-table-column prop="" label="结算状态" width="120">
            <template scope="scope">
              <span class="wsStyle" v-show="scope.row.yfSettlementStates == '-1'">未对账</span>
              <span class="wsStyle" v-show="scope.row.yfSettlementStates == '0'">未付款</span>
              <span class="bfStyle" v-show="scope.row.yfSettlementStates == '1'">部分付款</span>
              <span class="ysStyle" v-show="scope.row.yfSettlementStates == '2'">已付款</span>
              <span class="ysStyle" v-show="scope.row.yfSettlementStates == '3'">不付款</span>
            </template>
          </el-table-column>
          <el-table-column prop="settlementStatus" label="开票状态" width="120">
            <template scope="scope">
              <!-- 0.未开票、1.部分开票、2.已开票 -->
              <span class="wsStyle" v-show="scope.row.yfInvoicingStates == '0'">未开票</span>
              <span class="bfStyle" v-show="scope.row.yfInvoicingStates == '1'">部分开票</span>
              <span class="ysStyle" v-show="scope.row.yfInvoicingStates == '2'">已开票</span>
               <span class="ysStyle" v-show="scope.row.yfInvoicingStates == '3'">不开票</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="" label="付款风控状态" width="120" >
            <template scope="scope">
              <div>
                <span class="" v-show="scope.row.riskControlState == '0'">待推送</span>
                <span style="color:#E6A23C" v-show="scope.row.riskControlState == '1'">处理中</span>
                <span style="color:#67C23A" v-show="scope.row.riskControlState == '2'">已处理</span>
                <span style="color:#F56C6C" v-show="scope.row.riskControlState == '3'">处理失败</span>
                <span  v-show="scope.row.riskControlState == '4'">不推送</span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="khyNo" label="三方网货单号" width="160" :show-overflow-tooltip="true" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightPricingTypeName" label="运费计价" width="120" :formatter="formatterRowEmpty">
            <!-- <template scope="scope">
              0.按吨、1.按车、2.按方、3.按件
              <span v-show="scope.row.freightPricingType == '0'">按吨</span>
              <span v-show="scope.row.freightPricingType == '1'">按车</span>
              <span v-show="scope.row.freightPricingType == '2'">按方</span>
              <span v-show="scope.row.freightPricingType == '3'">按件</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="" label="运费单价" width="130">
            <template scope="scope">
              <div>
                <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                <span v-if="scope.row.freightPricingType == '1'">
                  <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="freightAmount" label="运费金额(元)" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceRate" label="服务费率(%)" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceCharge" label="服务费(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightTaxTotal" label="支出总额(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfPaymentAmount" label="已付款金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfNoPaymentAmount" label="未付款金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceAmount" label="已开票金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfNoInvoiceAmount" label="未开票金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="generalCarrier" label="承运方" width="300" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="projectType" label="项目名称" width="160"> </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceOn" label="发票号" width="200" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <!-- <div class="pags" style="text-align: left;">
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <!-- 添加应付 -->
    <div>
      <el-dialog :title="YFTitle" :visible.sync="YFAddMark" :close-on-click-modal="false" width="80%" center @close="closeDialog"
      >
        <div>
          <div >
            <el-form :inline="true" :model="YFAddFrom" class="demo-form-inline" size="mini" label-width="100px">
              <!-- <el-form-item label="创建时间:">
                <el-date-picker
                  v-model="createTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item> -->
              <el-form-item label="签收时间:">
                <el-date-picker
                  v-model="actualSignings"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="车牌号:">
                <el-input v-model="YFAddFrom.plateNumber" size="mini" placeholder="请输入车牌号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
                <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-table :data="listYFData" ref="listYFData" class="elTab" highlight-current-row border size="mini" style="width:100%"
            :header-cell-style="{background:'#F5F5F5',color:'black'}">
              <el-table-column type="selection" width="50" fixed></el-table-column>
              <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
              <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
              <el-table-column prop="expenditurePatternName" label="结算方式" width="90" :formatter="formatterRowEmpty">
                <!-- <template scope="scope">
                  <span v-show="scope.row.expenditurePattern == '0'">月结</span>
                  <span v-show="scope.row.expenditurePattern == '1'">现结</span>
                </template> -->
              </el-table-column>
              <el-table-column prop="" label="结算状态" width="100">
                <template scope="scope">
                  <span class="wsStyle" v-show="scope.row.yfSettlementStates == '-1'">未对账</span>
                  <span class="wsStyle" v-show="scope.row.yfSettlementStates == '0'">未付款</span>
                  <span class="bfStyle" v-show="scope.row.yfSettlementStates == '1'">部分付款</span>
                  <span class="ysStyle" v-show="scope.row.yfSettlementStates == '2'">已付款</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="" label="付款风控状态" width="120" >
                <template scope="scope">
                  <div>
                    <span class="" v-show="scope.row.riskControlState == '0'">待推送</span>
                    <span style="color:#E6A23C" v-show="scope.row.riskControlState == '1'">处理中</span>
                    <span style="color:#67C23A" v-show="scope.row.riskControlState == '2'">已处理</span>
                    <span style="color:#F56C6C" v-show="scope.row.riskControlState == '3'">处理失败</span>
                    <span  v-show="scope.row.riskControlState == '4'">不推送</span>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column prop="khyNo" label="三方网货单号" width="160" :show-overflow-tooltip="true" :formatter="formatterRowEmpty">
               </el-table-column>
              <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="productTypeName" label="货物类型" width="120">
              </el-table-column>
              <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="" label="计价方式" width="100">
                <template scope="scope">
                  <!-- 0.按吨、1.按车、2.按方、3.按件 -->
                  <span v-show="scope.row.freightPricingType == '0'">按吨</span>
                  <span v-show="scope.row.freightPricingType == '1'">按车</span>
                  <span v-show="scope.row.freightPricingType == '2'">按方</span>
                  <span v-show="scope.row.freightPricingType == '3'">按件</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="单价" width="130">
                <template scope="scope">
                  <div>
                    <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                    <span v-if="scope.row.freightPricingType == '1'">
                      <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                      <span v-else>-</span>
                    </span>
                    <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                    <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="freightAmount" label="运费金额(元)" width="140">
              </el-table-column>
              <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="130">
              </el-table-column>
              <el-table-column prop="serviceRate" label="服务费率(%)" width="130" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="serviceCharge" label="服务费(元)" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="freightTaxTotal" label="支出总额(元)" width="140" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
              <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div>
            <el-pagination background @current-change="handleCurrentChangeYFAdd" :current-page="YFAddFrom.pageNo" :page-size="YFAddFrom.pageSize"
              :page-sizes="[10,50,100,500,1000]" layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeYFAdd" :total="totalYFAdd"></el-pagination>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="saveFn">确定</el-button>
        </span>
      </el-dialog>
      <!-- 付款 -->
      <yiJianFuKuan v-if="fuKuanMark" :fuKuanMark.sync='fuKuanMark' :fuKuanFrom='fuKuanFrom' @refresh = 'getList' :detilsFlag = 'true'></yiJianFuKuan>
      <!-- 开票 -->
      <FuKuanKaiPiao v-if="kaiPiaoMark" :kaiPiaoMark.sync='kaiPiaoMark' :kaiPiaoFrom='kaiPiaoFrom' @refresh = 'getList' :detilsFlag = 'true'></FuKuanKaiPiao>
      <!-- 部分付款 -->
      <bufenFuKuan v-if="buFenFKMark" :buFenFKMark.sync='buFenFKMark' :buFenFKFrom='buFenFKFrom' @refresh = 'getList'></bufenFuKuan>
      <!-- 部分开票 -->
      <bufenKaiPiao v-if="buFenKPMark" :buFenKPMark.sync='buFenKPMark' :buFenKPFrom='buFenKPFrom' @refresh = 'getList' :shouKuanFlag = 'false'></bufenKaiPiao>
    </div>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { findWayBusinessList, addSettlementBillWayForYf, delSettlementBillWayForYf } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty } from '@/utils/util'
import yiJianFuKuan from '@/views/newTMS/publicFiles/caiWuYingFu/yiJianFuKuan.vue'
import FuKuanKaiPiao from '@/views/newTMS/publicFiles/caiWuYingFu/FuKuanKaiPiao.vue'
import bufenFuKuan from '@/views/newTMS/publicFiles/caiWuYingFu/bufenFuKuan.vue'
import bufenKaiPiao from '@/views/newTMS/publicFiles/caiWuYingShou/bufenKaiPiao.vue'
export default {
  name: 'Freight',
  components: {
    yiJianFuKuan,
    FuKuanKaiPiao,
    bufenFuKuan,
    bufenKaiPiao
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      emptyFn: emptyFn,
      YFAddMark: false,
      YFTitle: '添加应付',
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      formInline: {
        timeType: '1'
      },
      pagesize: 20,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00J0600', '01N00J0700', '01N00J0800', '01N00J0900', '01N00J0A00', '01N00J0B00'],
      tableList: [],
      createTimes: [],
      actualSignings: [],
      YFAddFrom: {
        payerType: '1',
        payer: this.$route.query.payer,
        settlementPattern: this.$route.query.settlementPattern,
        yfSettlementStates: '-1',
        // makeTicketYn: this.$route.query.makeTicketYn,
        wayState: '4',
        // businessUnit: this.$route.query.businessUnit,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      totalYFAdd: 0,
      listYFData: [],
      duiZhangData: {
        wayNumber: 0, // 运单数量
        totalAmount: 0// 选中的应收总额
      },
      ids: [],
      fuKuanMark: false,
      fuKuanFrom: {
        pendingAmount: 0
      },
      kaiPiaoMark: false,
      kaiPiaoFrom: {
        invoiceAmount: 0
      },
      buFenFKMark: false,
      buFenFKFrom: {},
      buFenKPMark: false,
      buFenKPFrom: {},
      searchFrom: {},
      yfInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未开票',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ]
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yingFuSettlement')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 100 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.wayNos) {
        let str = this.searchFrom.wayNos.trim().replace(/\n/g, ',')
        this.searchFrom.wayNoList = str.split(',')
      } else {
        this.$set(this.searchFrom, 'wayNos', '')
        this.searchFrom.wayNoList = null
      }
      this.searchFrom.yfSettlementBillId = this.$route.query.yfSettlementBillId
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res
        // this.total = res.total
        // this.map = res.map
      })
    },
    chongZhi1 () {
      this.searchFrom = {
        yfSettlementBillId: this.$route.query.yfSettlementBillId
      }
      this.getList()
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    delFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.duiZhangData.totalAmount = 0
        selectData.forEach((item, index) => {
          this.duiZhangData.totalAmount += item.freightTaxTotal
          this.duiZhangData.wayNumber = index + 1
          this.ids.push(item.id)
        })
        this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
        this.$set(this.duiZhangData, 'ids', this.ids.toString())
        this.$set(this.duiZhangData, 'id', this.$route.query.yfSettlementBillId)
        console.log(this.duiZhangData, 'this.duiZhangData')
        this.$confirm('是否删除？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          delSettlementBillWayForYf(this.duiZhangData).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.getList()
          })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        }).catch(() => { })
      }
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getList()
    },
    // 点击添加应收
    addYFFn () {
      this.YFAddMark = true
      this.listYFData = []
      this.getYFList()
    },
    handleCurrentChangeYFAdd (val) {
      this.YFAddFrom.pageNo = val
      this.getYFList()
    },
    handleSizeChangeYFAdd (val) {
      this.YFAddFrom.pageSize = val
      this.getYFList()
    },
    getYFList () {
      this.loading = true
      // this.YFAddFrom.createTimeStart = this.createTimes[0]
      // this.YFAddFrom.createTimeEnd = this.createTimes[1]
      this.YFAddFrom.actualSigningTimeStart = this.actualSignings[0]
      this.YFAddFrom.actualSigningTimeEnd = this.actualSignings[1]
      findWayBusinessList(this.YFAddFrom).then(res => {
        this.loading = false
        this.listYFData = res.list
        this.totalYFAdd = res.total
      })
    },
    // 查询
    chaxun () {
      this.getYFList()
    },
    chongZhi () {
      this.YFAddFrom = {
        payerType: '1',
        payer: this.$route.query.payer,
        settlementPattern: this.$route.query.settlementPattern,
        yfSettlementStates: '-1',
        // makeTicketYn: this.$route.query.makeTicketYn,
        // businessUnit: this.$route.query.businessUnit,
        wayState: '4',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTimes = []
      this.actualSignings = []
      this.getYFList()
    },
    // 选择数据
    selectGoods (selectData) {
      console.log(selectData, 'selectData')
      let totalAmount = 0
      let invoiceAmount = 0
      selectData.forEach((item, index) => {
        totalAmount += item.yfNoPaymentAmount
        invoiceAmount += item.yfNoInvoiceAmount
      })
      console.log(totalAmount, 'totalAmount')
      totalAmount = this.toFixed(totalAmount, 2)
      invoiceAmount = this.toFixed(invoiceAmount, 2)
      this.$set(this.fuKuanFrom, 'pendingAmount', totalAmount)
      this.$set(this.kaiPiaoFrom, 'invoiceAmount', invoiceAmount)
      // this.$set(this.shouKuanFrom,'wayNumber',selectData.length)
    },
    saveFn () {
      let selectData = this.$refs.listYFData.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.duiZhangData.totalAmount = 0
        selectData.forEach((item, index) => {
          this.duiZhangData.totalAmount += item.freightTaxTotal
          this.duiZhangData.wayNumber = index + 1
          this.ids.push(item.id)
        })
        this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
        this.$set(this.duiZhangData, 'ids', this.ids.toString())
        this.$set(this.duiZhangData, 'id', this.$route.query.yfSettlementBillId)
        console.log(this.duiZhangData, 'this.duiZhangData')
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addSettlementBillWayForYf(this.duiZhangData).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.YFAddMark = false
          this.getList()
        })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    // 点击关闭弹窗
    closeDialog () {
      this.YFAddMark = false
      this.YFAddFrom = {
        payerType: '1',
        payer: this.$route.query.payer,
        settlementPattern: this.$route.query.settlementPattern,
        yfSettlementStates: '-1',
        // makeTicketYn: this.$route.query.makeTicketYn,
        // businessUnit: this.$route.query.businessUnit,
        wayState: '4',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      // this.createTimes = []
      this.actualSignings = []
    },
    // 点击付款
    fuKuanFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagA = selectData.every(item => item.yfSettlementStates != '2')
        if (!flagA) {
          this.$alert('只能选择未付款或部分付款的数据', '系统提示')
          return
        }
        // let flagB = selectData.every(item => item.riskControlState == '4')
        // if (!flagB) {
        //   this.$alert('此账单结算结果由风控平台反馈，不可操作', '系统提示')
        //   return
        // }
        let fuKuanIds = []
        let totalAmount = 0
        selectData.forEach((item, index) => {
          totalAmount += item.yfNoPaymentAmount
          fuKuanIds.push(item.id)
        })
        totalAmount = this.toFixed(totalAmount, 2)
        this.$set(this.fuKuanFrom, 'ids', fuKuanIds.toString())
        this.$set(this.fuKuanFrom, 'settlementBillId', this.$route.query.yfSettlementBillId)
        this.$set(this.fuKuanFrom, 'recordType', 0)
        this.$set(this.fuKuanFrom, 'pendingAmount', totalAmount)
        this.$set(this.fuKuanFrom, 'collectionAmount', totalAmount)
        this.$set(this.fuKuanFrom, 'wayNumber', selectData.length)
        this.fuKuanMark = true
        console.log(this.fuKuanFrom, 'this.fuKuanFrom')
        // 参数 以下都必填
        // ids 运单业务表id逗号拼接
        // settlementBillId 账单表主键id
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 收款金额（待收金额）
        // collectionAmount 收款金额（收款金额）
        // collectionTime 收款时间 日期类型
        // wayNumber 运单数量
      }
    },
    // 点击开票
    kaiPiaoFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagB = selectData.every(item => item.yfInvoicingStates != '2')
        if (!flagB) {
          this.$alert('只能选择未开票或部分开票的数据', '系统提示')
          return
        }
        let flagE = false
        let wayNos = []
        selectData.some(item => {
          if (item.riskControlState == 1 || item.riskControlState == 3) {
            wayNos.push(item.wayNo)
            flagE = false
            return true
          } else {
            flagE = true
          }
        })
        // if (!flagE) {
        //   this.$alert('存在风控未处理完成或处理失败的运单，运单号' + wayNos.toString() + '不可开票！', '系统提示')
        //   return
        // }
        let kaiPiaoIds = []
        let invoiceAmount = 0
        selectData.forEach((item, index) => {
          invoiceAmount += item.yfNoInvoiceAmount
          kaiPiaoIds.push(item.id)
        })
        invoiceAmount = this.toFixed(invoiceAmount, 2)
        console.log(invoiceAmount, 'invoiceAmount')
        this.$set(this.kaiPiaoFrom, 'ids', kaiPiaoIds.toString())
        this.$set(this.kaiPiaoFrom, 'settlementBillId', this.$route.query.yfSettlementBillId)
        this.$set(this.kaiPiaoFrom, 'recordType', 0)
        this.$set(this.kaiPiaoFrom, 'wayNumber', selectData.length)
        this.$set(this.kaiPiaoFrom, 'invoiceAmount', invoiceAmount)
        this.$set(this.kaiPiaoFrom, 'pendingAmount', invoiceAmount)
        this.kaiPiaoMark = true
        // 参数 以下都必填
        // ids 运单业务表id逗号拼接
        // settlementBillId 账单表主键id
        // invoiceNo 发票号码
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 开票金额（待开金额）
        // invoiceAmount 开票金额（开票金额）
        // invoiceTime 开票时间 日期类型
        // wayNumber 运单数量
      }
    },
    // 部分付款
    buFenFKFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].yfSettlementStates == '2') {
          this.$alert('只能选择未付款或部分付款的数据', '系统提示')
          return
        }
        // if (selectData[0].riskControlState != '4') {
        //   this.$alert('此账单结算结果由风控平台反馈，不可操作', '系统提示')
        //   return
        // }
        this.$set(this.buFenFKFrom, 'wayBusinessId', selectData[0].id)
        this.$set(this.buFenFKFrom, 'settlementBillId', this.$route.query.yfSettlementBillId)
        this.$set(this.buFenFKFrom, 'recordType', 1)
        this.$set(this.buFenFKFrom, 'wayNumber', 1)
        this.$set(this.buFenFKFrom, 'pendingAmount', selectData[0].yfNoPaymentAmount)
        this.buFenFKMark = true
        // 参数 以下都必填
        // id 运单业务表id
        // settlementBillId 账单表主键id
        // recordType 传固定值1 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 待收金额
        // collectionAmount 收款金额
        // collectionTime 收款时间 日期类型
        // wayNumber 运单数量 1
      }
    },
    // 点击部分开票
    buFenKPFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].yfInvoicingStates == '2') {
          this.$alert('只能选择未开票或部分开票的数据', '系统提示')
          return
        }
        // if (selectData[0].riskControlState == 1 || selectData[0].riskControlState == 3) {
        //   this.$alert('存在风控未处理完成或处理失败的运单，不可开票！', '系统提示')
        //   return
        // }
        this.$set(this.buFenKPFrom, 'wayBusinessId', selectData[0].id)
        this.$set(this.buFenKPFrom, 'settlementBillId', this.$route.query.yfSettlementBillId)
        this.$set(this.buFenKPFrom, 'recordType', 1)
        this.$set(this.buFenKPFrom, 'wayNumber', 1)
        this.$set(this.buFenKPFrom, 'pendingAmount', selectData[0].yfNoInvoiceAmount)
        this.buFenKPMark = true
        // 参数 以下都必填
        // id 运单业务表id
        // settlementBillId 账单表主键id
        // invoiceNo 发票号码
        // recordType 传固定值 1 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 待开金额
        // invoiceAmount 开票金额
        // invoiceTime 开票时间 日期类型
        // wayNumber 运单数量 1
      }
    },
    back () {
      // this.$router.go(-1)// 返回上一层
      this.$router.push({ name: 'yingFuSettlement', query: { ZDFlag: true } })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 315px !important;
}
/deep/.inpBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
.el-form-item {
  margin-left: 10px;
}
</style>
